
export function isMobile() {
    if (navigator.userAgent.match(/Mobi/)) {
        return true; // Mobile user agent detected
    }

    if ('ontouchstart' in window) {
        return true; // Touch events are supported
    }

    // Additional checks can be added here, if necessary

    return false; // Not a mobile device
}